import React from "react";
import { Box } from "@mui/material";
import importedStyles from "../../styles/Inbox.module.css";

export default function PostDetailsCard() {
  return (
    <Box sx={styles.wrapper}>
      <Box>
        <Box sx={styles.imgContainer}>
          <img
            src="https://placehold.co/150/green/white"
            alt="social post image"
            className={importedStyles.socialPostImg}
          />
        </Box>
      </Box>

      <Box>
        <Box display="flex" gap="10px">
          <Box sx={styles.smTag}>lg</Box>
          <Box
            sx={{
              ...styles.smTag,
              color: "#b5602a",
              backgroundColor: "#fbe9d9",
            }}
          >
            Paid Ad
          </Box>
        </Box>

        <Box as="p" sx={styles.caption}>
          Meet the Walnut Console — solid wood, felt-lined drawers, and free
          white-glove delivery this week only. Tap to shop the collection. ✦
        </Box>

        <Box as="p" sx={styles.stats}>
          <span>2,481 likes</span>
          <span>184 comments</span>
          <span>39.2k reach</span>
        </Box>
      </Box>
    </Box>
  );
}

const styles = {
  wrapper: {
    backgroundColor: "#FFFFFF",
    borderRadius: "14px",
    padding: "16px",
    display: "flex",
    alignItems: "flex-start",
    gap: "16px",
    boxShadow: "rgba(18, 38, 27, 0.05) 0px 1px 3px",
  },
  imgContainer: {
    height: "150px",
    width: "150px",
    borderRadius: "14px",
    overflow: "hidden",
    border: "1px solid #f0ece5",
  },
  smTag: {
    padding: "3px 7px",
    borderRadius: "6px",
    fontFamily: "FustatBold",
    fontSize: "11px",
    backgroundColor: "#d6336c",
    color: "#ffffff",
  },
  caption: {
    fontFamily: "FustatMedium",
    color: "#1a2b20",
    fontSize: "16px",
    mb: 2,
    mt: 1,
  },
  stats: {
    color: "#55605a",
    fontSize: "14px",
    fontFamily: "FustatMedium",
    display: "flex",
    alignItems: "center",
    gap: "20px",
  },
};
